import { ConnectProto } from "@racoon/api";

/**
 * A СО trip carries one container at a time (construction / multilift trucks), so
 * several СО jobs cannot land on one trip together.
 */
export const hasSeveralCoJobs = (jobs: Pick<ConnectProto.Job, "jobCategory">[]): boolean =>
  jobs.filter((job) => job.jobCategory === ConnectProto.JobCategory.CO).length > 1;
